import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import ToastReducer from "./ToastReducer";
import BackdropReducer from "./BackdropReducer";
import SocketAuthReducer from "./SocketAuthReducer";

const reducers = combineReducers({
  auth: AuthReducer,
  toaster: ToastReducer,
  backdrop: BackdropReducer,
  socketAuth: SocketAuthReducer,
});

export default reducers;
